import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyModule } from '@ngx-formly/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { constants } from './shared/constants';
import { UtilityService } from './core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from './core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { HomeComponent } from './home/home.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SharedModule } from './shared/shared.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { LandingResolver } from './landing/landing.resolver';
import { QuestionareComponent, SafePipe } from './questionare/questionare/questionare.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ClipboardModule } from 'ngx-clipboard';
import { IylonProductsComponent } from './mobile/iylon-products/iylon-products.component';
import { IylonConnectComponent } from './iylon-connect/iylon-connect.component';
import { ConnectPaymentComponent } from './connect-payment/connect-payment.component';
import { CalendarModule } from 'primeng/calendar';

export class TranslateHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    const defaultValue = UtilityService.getValue(constants.Resources, params.key);
    console.log('Missing :' + defaultValue);
    return defaultValue ? defaultValue : ' '; // here u can return translation
  }
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    QuestionareComponent,
    SafePipe,
    IylonProductsComponent,
    IylonConnectComponent,
    ConnectPaymentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormlyPrimeNGModule,
    BrowserAnimationsModule,
    ConfirmDialogModule,
    TableModule,
    ToastModule,
    DialogModule,
    CalendarModule,
    DynamicDialogModule,
    ClipboardModule,
    FormlyModule.forRoot({
      validationMessages: [
        { name: 'required', message: 'This field is required' },
      ],
    }),
    TranslateModule.forRoot({
      isolate: false,
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: TranslateHandler },
      useDefaultLang: true
    }),
    CoreModule.forRoot(),
    SharedModule.forRoot(),
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    FormlyModule.forRoot({ extras: { lazyRender: true } })
  ],
  providers: [ConfirmationService, MessageService, LandingResolver],
  bootstrap: [AppComponent]
})
export class AppModule { }
